
































































































































import { Vue, Component } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import BasicSelect from '@components/common/BasicSelect.vue';
import BaseDatePicker from '@/components/common/BaseDatePicker.vue';
import PageLoader from '@components/common/PageLoader.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { State } from 'vuex-class';
import { CS_USER_STATE_FILTERS, DEFAULT_USER_STATE_FILTERS, HANDLER_TYPE, NEW_USER_STATE, NEW_USER_STATE_NAME } from '@/common/constants/auth';
import lodash from 'lodash';
import Multiselect from 'vue-multiselect';
import PatientItem from '@components/v2/patient/PatientItem.vue';
import ApiHelper from '@/api/ApiHelper';
import Toast from '@common/helpers/toast';
import Encoding from 'encoding-japanese';
import moment from 'moment-timezone';

@Component({
  components: {
    PageLoader,
    PatientItem,
    VuePerfectScrollbar,
    InfiniteLoading,
    BasicSelect,
    Multiselect,
    BaseDatePicker,
  },
})
export default class Channel extends Vue {
  @State((state) => state.patient_list.data) patientList!: any;
  @State((state) => state.auth.currentUser) currentUser!: any;
  private query = '';
  private delayId: any = null;
  private selectedStates: any = [];
  private stateOptions: any[] = [];
  private selectedSort: string = '';
  private sortOptions: any[] = [
    { name: '並び替え', value: '' },
    { name: '名前 昇順', value: 'family_name_kana' },
    { name: '名前 降順', value: '-family_name_kana' },
    { name: '登録日 昇順', value: 'registered_at' },
    { name: '登録日 降順', value: '-registered_at' },
    { name: '更新日 昇順', value: 'updated_at' },
    { name: '更新日 降順', value: '-updated_at' },
    { name: '返信状態 昇順', value: 'send_message_at' },
    { name: '返信状態 降順', value: '-send_message_at' },
  ];
  private pathName = this.$route.matched[1].path;
  private activeTab: any = '';
  private showCheckbox: boolean = false;
  private listSkipMess: any = [];
  private exSearch: any = {
    date_from: null,
    date_to: null,
  };
  private exBtnLoading = false;

  created() {
    this.stateOptions.push(
      { name: 'クリア', value: 'clear_all' },
      ...this.makeStateOption(),
      ...this.makeHandlerTypeOption(),
    );
    this.setInputValueFromQueryData();
    this.setSearchDefaultState();
    this.setUrlWithQuery();
    this.setStateOptionsForOrtherRoleDoctor();

    if (this.$refs.InfiniteLoading) {
      (this.$refs.InfiniteLoading as any).stateChanger.reset();
    }
    this.$store.commit('patient_list/resetPatientListState');
  }

  beforeDestroy() {
    this.$store.commit('patient_list/resetPatientListState');
  }

  showAndHide() {
    this.showCheckbox = !this.showCheckbox;
    this.listSkipMess = [];
  }

  showButtonCheckbox() {
    if (
      !(
        this.currentUser.isDoctorRole &&
        !!this.selectedStates.find(
          (item: any) => item.value === NEW_USER_STATE.DOCTOR_CHAT_UNREPLY,
        )
      )
    ) {
      this.showCheckbox = false;
    }
    return (
      this.currentUser.isDoctorRole &&
      !!this.selectedStates.find(
        (item: any) => item.value === NEW_USER_STATE.DOCTOR_CHAT_UNREPLY,
      )
    );
  }

  showBoxExport() {
    return this.currentUser.isSuperAdminRole;
  }

  async submitCheckbox() {
    await ApiHelper.getApi('PatientV2Api')
      .skipMessages({ user_ids: this.listSkipMess })
      .then((res: any) => {
        this.showAndHide();
        this.debouncedSearch(this.selectedStates);
        Toast.success('対応済みに変更しました。');
      })
      .catch((err: any) => {
        Toast.error(err.message || '対応済みが変更できません。');
      });
  }

  async submitExportPatientList() {
    if (this.exBtnLoading) {
      return;
    }

    this.exBtnLoading = true;

    await ApiHelper.getApi('PatientV2Api')
      .exportPatientList(this.exSearch)
      .then((users: any) => {
        const formatDate = (date) =>
          moment(date || new Date()).format('YYYY年MM月DD日');

        const dateFromStr = this.exSearch.date_from
          ? formatDate(this.exSearch.date_from)
          : '';
        const dateToStr = this.exSearch.date_to
          ? `~${formatDate(this.exSearch.date_to)}`
          : dateFromStr ? `~${formatDate(null)}` : '';
        const fileName = `患者一覧_${
          dateFromStr || dateToStr ? '' : formatDate(null)
        }${dateFromStr}${dateToStr}.csv`;

        this.transformBlobToFile(users, fileName);
      })
      .catch((err: any) => {
        Toast.error(err.message || '対応済みが変更できません。');
      })
      .finally(() => {
        this.exBtnLoading = false;
      });
  }

  transformBlobToFile(data, file) {
    const uniArray = Encoding.stringToCode(data);
    const sjisArray = Encoding.convert(uniArray, {
      to: 'SJIS',
      from: 'UNICODE',
    });
    const unit8Array = new Uint8Array(sjisArray);
    const blob = new Blob([unit8Array], { type: 'text/csv;charset=Shift_JIS' });

    if (window.navigator.msSaveOrOpenBlob) {
      // for IE,Edge
      window.navigator.msSaveOrOpenBlob(blob, file);
    } else {
      // for chrome, firefox
      const url = URL.createObjectURL(blob);
      const linkEl: any = document.createElement('a');
      linkEl.href = url;
      linkEl.setAttribute('download', file);
      document.body.appendChild(linkEl);
      linkEl.click();

      URL.revokeObjectURL(url);
      linkEl.parentNode.removeChild(linkEl);
    }
  }

  checkbox(status, patient) {
    this.listSkipMess = status
      ? [...this.listSkipMess, patient?.id]
      : this.listSkipMess.filter((item: any) => item !== patient?.id);
  }

  isDisableSubmitCheckbox() {
    if (this.showCheckbox && this.listSkipMess.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  debouncedSearch(selected) {
    this.listSkipMess = [];
    if (
      lodash.isArray(selected) &&
      selected.findIndex((option) => option.value === 'clear_all') !== -1
    ) {
      this.selectedStates = [];
    }
    if (lodash.get(this.selectedStates, '0.value', '') === '') {
      this.selectedStates = [];
    }
    clearTimeout(this.delayId);
    this.$nextTick(() => {
      this.delayId = setTimeout(this.onSearch, 2000);
    });
  }

  onSearch($state) {
    this.setUrlWithQuery(this.getCurrentPage());
    (this.$refs.infiniteLoading as any).stateChanger.reset();
    this.$store.commit('patient_list/resetPatientListState');
  }

  private isNotLastItem(index) {
    return index + 1 != this.patientList.length;
  }

  private setUrlWithQuery(path: string | null = null) {
    this.$router.push({
      path: path ? path : this.$route.path,
      query: { ...this.$route.query, ...this.makeSearchParams() },
    });
  }

  private makeSearchParams() {
    const stateParams = this.getStatusSearch();
    const handlerParam = this.getHandlerTypeSearch();

    const params: any = {
      state: stateParams,
      search: this.query || '',
      order: this.selectedSort || '',
      time: lodash.now().toString(),
      tab: this.activeTab || '',
    };

    if (handlerParam) {
      params.handler_type = handlerParam;
    }

    return params;
  }

  private makeQueryParams() {
    return location.search;
  }

  private setSearchDefaultState() {
    if (this.$route.query.state || this.$route.query.search) {
      return;
    }

    const build = (states: Record<string, string>) =>
      Object.keys(states).map((key) => ({
        name: NEW_USER_STATE_NAME[key],
        value: states[key],
        type: 'state',
      }));

    this.selectedStates = this.currentUser.isCSRole
      ? build(CS_USER_STATE_FILTERS)
      : build(DEFAULT_USER_STATE_FILTERS);
  }

  private makeHandlerTypeOption() {
    return [
      { name: 'CS対応中', value: HANDLER_TYPE.CS || 'cs', type: 'handler' },
      { name: 'ドクター対応中', value: HANDLER_TYPE.DOCTOR || 'doctor', type: 'handler' },
    ];
  }

  private setStateOptionsForOrtherRoleDoctor() {
    if (!this.currentUser?.isDoctorRole) {
      const namesToRemove = [
        NEW_USER_STATE_NAME.DOCTOR_CHAT_UNREPLY,
        NEW_USER_STATE_NAME.DOCTOR_RESERVE_PRESCRIPTION,
        NEW_USER_STATE_NAME.DOCTOR_CHAT_REPLIED,
        NEW_USER_STATE_NAME.CHAT_INTERVIEW_SCHEDULED,
        NEW_USER_STATE_NAME.CHAT_CONSULTATION_IN_PROGRESS,
      ];
      this.stateOptions = this.stateOptions.filter(
        (state) => !namesToRemove.includes(state.name),
      );
      this.selectedStates = this.selectedStates.filter(
        (state) => !namesToRemove.includes(state.name),
      );
    }
  }

  private setInputValueFromQueryData() {
    const query = this.$route.query;
    let stateList: any = [];

    if (lodash.isString(query.state)) {
      stateList.push(query.state);
    }
    if (lodash.isArray(query.state)) {
      stateList = query.state;
    }

    const handlerParam = query.handler_type ? String(query.handler_type) : null;
    this.selectedStates = this.getStateObjectList(stateList);
    this.query = query.search ? query.search.toString() : '';
    this.selectedSort = query.order ? query.order.toString() : '';
    this.activeTab = query?.tab ? query?.tab : '';
  }

  private getStateObjectList(stateList: string[]) {
    return lodash.compact(
      (stateList || []).map((state) => {
        if ([HANDLER_TYPE.CS, HANDLER_TYPE.DOCTOR, HANDLER_TYPE.ALL].includes(state as any)) {
          return null;
        }
        return {
          name: NEW_USER_STATE_NAME[state?.toUpperCase()],
          value: state,
          type: 'state',
        };
      }),
    );
  }

  private getHandlerObjectFromValue(value: string) {
    if (!value) {
      return [];
    }
    const mapping: any = {
      [HANDLER_TYPE.CS || 'cs']: { name: 'CS対応中', value: HANDLER_TYPE.CS || 'cs', type: 'handler' },
      [HANDLER_TYPE.DOCTOR || 'doctor']: { name: 'ドクター対応中', value: HANDLER_TYPE.DOCTOR || 'doctor', type: 'handler' },
    };
    return mapping[value] ? [mapping[value]] : [];
  }

  private getCurrentPage() {
    return location.pathname;
  }

  private async loadData($state) {
    const payload = {
      manager_query: this.query,
      new_state: this.getStatusSearch(),
      handler_type: this.getHandlerTypeSearch(),
      order: this.selectedSort,
    };
    await this.$store.dispatch('patient_list/getPatientList', {
      payload,
      $state,
    });
  }

  private getStatusSearch() {
    if (!this.selectedStates || !this.selectedStates.length) {
      return [];
    }

    return this.selectedStates
      .filter((s) => s.type === 'state')
      .map((s) => s.value);
  }

  private getHandlerTypeSearch() {
    if (!this.selectedStates || !this.selectedStates.length) {
      return null;
    }

    const handlers = this.selectedStates.filter((s) => s.type === 'handler');
    if (!handlers.length) {
      return null;
    }

    return handlers.map((h) => h.value);
  }

  private makeStateOption = () => {
    const data: any = [];
    Object.keys(NEW_USER_STATE).map((name) => {
      data.push({
        name: NEW_USER_STATE_NAME[name],
        value: NEW_USER_STATE[name],
        type: 'state',
      });
    });

    return data;
  }

  private reloadPatientList() {
    // reload patient list for patient component
    (this.$refs.infiniteLoading as any).stateChanger.reset();
  }
}
